import { getProfileLinkProps } from "@circle-react/helpers/profileHelpers";

const GROUP_MENTION_TYPES = ["GroupMention", "group_mention"];

export const isGroupMention = (type: string) =>
  GROUP_MENTION_TYPES.includes(type);

export const getMentionHref = ({
  public_uid,
  type,
}: {
  public_uid: string;
  type: string;
}): string | undefined => {
  if (isGroupMention(type)) return undefined;
  return getProfileLinkProps({
    publicUid: public_uid,
    params: {},
    shouldOpenInNewTab: true,
    showMemberProfileDrawer: () => {},
  }).href;
};
